import axiosInstance from "../libs/axiosInstance";


export const initializeSubscription = async (plan) => {
    try {
      const response = await axiosInstance.post('/subscriptions/initialize/', {
        plan: plan
      });
      return response.data;
    } catch (error) {
      console.error('Error iitializing subscription:', error.message);
      throw error;
    }
};

export const verifySubscription = async (reference) => {
    try {
      const response = await axiosInstance.get('/subscriptions/verify/', { 
        params: { reference }
       });
      return response.data;
    } catch (error) {
      console.error('Error verifying subscription:', error);
      throw error;
    }
}

export const cancelSubscription = async () => {
  try {
    const response = await axiosInstance.post('/subscriptions/cancel/');
    return response.data;
  } catch (error) {
    console.error("Error cancelling subscription:", error);
    throw error;
  }
};

// Get active subscription
export const getActiveSubscription = async () => {
  try {
    const response = await axiosInstance.get('/subscriptions/active/');
    return response.data;
  } catch (error) {
    console.error("Error fetching active subscription:", error);
    throw error;
  }
};

// Get user payments
export const getUserPayments = async () => {
  try {
    const response = await axiosInstance.get('/subscriptions/payments/');
    return response.data;
  } catch (error) {
    console.error("Error fetching user payments:", error);
    throw error;
  }
};

// Download payment receipt (returns Blob)
export const getPaymentReceipt = async (reference) => {
  try {
    const response = await axiosInstance.get(`/subscriptions/receipt/${reference}/`, {
      responseType: 'blob',
      timeout: 45000, // 45 seconds timeout
    });
    return response;
  } catch (error) {
    console.error("Error fetching payment receipt:", error);
    throw error;
  }
};

// Apply for Enterprise plan
export const applyEnterprise = async ({ token = null, email = null }) => {
  try {
    const payload = {};
    if (token) payload.token = token;
    if (email) payload.email = email;

    const response = await axiosInstance.post('/subscriptions/enterprise/apply/', payload);
    return response.data;
  } catch (error) {
    console.error("Error applying for enterprise plan:", error);
    throw error;
  }
};

// Get admin list of enterprise applications
export const getAdminEnterpriseApplications = async (status = null) => {
  try {
    const params = {};
    if (status && status !== 'all') params.status = status;
    const response = await axiosInstance.get('/subscriptions/admin/enterprise/applications/', { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching admin enterprise applications:", error);
    throw error;
  }
};

// Decide (approve or reject) an enterprise application
export const decideEnterpriseApplication = async (id, { status, admin_notes = "", duration }) => {
  try {
    const response = await axiosInstance.post(`/subscriptions/admin/enterprise/applications/${id}/decide/`, {
      status,
      admin_notes,
      ...(duration ? { duration } : {})
    });
    return response.data;
  } catch (error) {
    console.error(`Error deciding enterprise application ${id}:`, error);
    throw error;
  }
};




